import { createSlice } from '@reduxjs/toolkit';
import { FreezerListState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { listFreezersThunk } from './thunks';

// Initial State
const initialState: FreezerListState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const freezerListSlice = createSlice({
  name: 'cryoboxList',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(listFreezersThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(listFreezersThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(listFreezersThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset } = freezerListSlice.actions;
export * from './thunks';
export * from './selectors';
export default freezerListSlice.reducer;
